import React from "react";
import MessageBubble from "./MessageBubble";
import iconMessage from "../../assets/icons/iconMessage.svg";
import styles from "./MessageList.module.css";

const MessageList = ({ messages, messagesEndRef, formatTime }) => {
  if (messages.length === 0) {
    return (
      <div className={styles.emptyState}>
        <div className={styles.emptyStateBackground}></div>
        <div className={styles.emptyStateContent}>
          <img src={iconMessage} alt="" className={styles.emptyStateIcon} />
          <p className={styles.emptyStateText}>
            Отправьте сообщение, чтобы начать диалог с ИИ
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.messagesArea}>
      {messages.map((message, index) => (
        <div
          key={index}
          className={`${styles.message} ${
            message.role === "user" ? styles.messageUser : ""
          }`}
        >
          <div
            className={`${styles.messageContent} ${
              message.role === "user" ? styles.messageContentUser : ""
            }`}
          >
            <MessageBubble message={message} formatTime={formatTime} />
          </div>
        </div>
      ))}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
